'use es6';

import 'sporks!../bundles/before.js';
import * as authOnlyTracker from './authOnlyTracker';
authOnlyTracker.initialize(trackWhenAuthed => {
  // Auto-track pageview on script load
  trackWhenAuthed('autoPageView', {
    screen: 'initialized'
  }); // Globally set the tracker

  window.trackWhenAuthed = trackWhenAuthed;
});